import { render } from "./AuthDashboard.vue?vue&type=template&id=5d6d8f38&scoped=true"
import script from "./AuthDashboard.vue?vue&type=script&lang=js"
export * from "./AuthDashboard.vue?vue&type=script&lang=js"

import exportComponent from "C:\\agent\\_work\\39\\s\\Infosit.Cms.Web.v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d6d8f38"]])

export default __exports__